
function Errorpage() {
  return (
    document.body.innerHTML="<div><center>404 Page Not Found</center></div>"
  )
}

export default Errorpage
